<div class="m-expandable-layout"
     :class="styleClasses">
    <div class="m-expandable-layout__main">
        <slot></slot>
    </div>
    <div class="m-expandable-layout__panel"
         :style="panelStyle">
        <div class="m-expandable-layout__panel-content"
             :style="panelContentStyle"
             ref="panelContent">
            <slot name="panel"></slot>
        </div>
    </div>
</div>
